import { CoverageLevelValue } from '../types';

export const getIsCoverageCostNeeded = (coverageLevels: CoverageLevelValue[]): boolean => {
	return coverageLevels.some((coverageLevel) => coverageLevel.isSelected && typeof coverageLevel.totalCost !== 'number');
};
